import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AdminLoginForm from "./pages/LoginForm";
import EmployeeLoginForm from "./pages/EmployeeLoginForm";
import Dashboard from "./pages/Dashboard";
import EmployeeInfoForm from "./pages/EmployeeInfoForm";
import StudentEnrollmentForm from "./pages/StudentEnrollmentForm";
import Employeereports from "./pages/EmployeeReports";
import Studentreports from "./pages/StudentReportform";
import Layout from "./components/Layout";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  // Check authentication from sessionStorage instead of hardcoded true
  const isAuthenticated = true;
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<AdminLoginForm />} />
        <Route path="/login" element={<AdminLoginForm />} />
        <Route path="/employee-login" element={<EmployeeLoginForm />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <Layout>
               <Dashboard/>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/employee-information"
          element={
            isAuthenticated && isAdmin ? (
              <Layout>
                <EmployeeInfoForm />
              </Layout>
            ) : (
              <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
            )
          }
        />
        <Route
          path="/student-enrollment"
          element={
            isAuthenticated ? (
              <Layout>
                <StudentEnrollmentForm />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/student-reports"
          element={
            isAuthenticated ? (
              <Layout>
                <Studentreports />
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/employee-reports"
          element={
            isAuthenticated && isAdmin ? (
              <Layout>
                <Employeereports />
              </Layout>
            ) : (
              <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />
            )
          }
        />
        <Route
          path="*"
          element={<Navigate to="/login" replace />}
        />
      </Routes>

    </Router>
  );
};

export default App;